import React from 'react';

export default class ActivityIndicator extends React.Component {
  render() {
    return (
      <div id="loading"/>
    );
  }
}
